<template>
  <div>
    <div class="box box-success">
      <!-- <div
        class="box-header with-border"
        v-show="true"
        style="text-align:center; font-size: 14px;text-align:left;color:#5b6c7f;"
      >
        <h3 class="box-title">{{ $t("search.title") }}</h3>
      </div> -->
      <div class="box-body">
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-sm-3 col-md-3 col-lg-3">
            <!-- button show send Notification -->
            <lte-button
              id="searchButton"
              type="button"
              class="btn btn-labeled btn-success"
              @click="doOpenNotification"
            >
              <span class="btn-label">
                <i class="fa fa-th-list"></i>
              </span>
              {{ $t("notification.btn_notification") }}
            </lte-button>
          </div>
        </div>
        <div v-if="isShowNotification">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                {{ $t("notification.btn_notification") }}
              </h3>
              <!-- <lte-button
                id="searchButton"
                type="button"
                class="btn btn-labeled btn-info pull-right"
                @click="doOpenUser"
              >
                <span class="btn-label">
                  <i class="glyphicon glyphicon-user"></i>
                </span>
                {{ $t("notification.chooseTemplateConfig") }}
              </lte-button> -->
            </div>
            <div>
              <div class="col-md-12" style="margin-top: 10px">
                <div class="input-group">
                  <span class="input-group-btn">
                    <!-- <button class="btn btn-default reveal" type="button">
                      {{ $t("notification.modal_title") }}
                    </button> -->
                    <button
                      type="button"
                      class="btn btn-labeled btn-primary"
                      @click="doOpenUser('TO')"
                    >
                      <span class="btn-label">
                        <i class="fa fa-building-o"></i>
                      </span>
                      {{ $t("apartment.name") }}
                    </button>
                  </span>
                  <vue-input-tag
                    v-model="apartmentCodeSelect"
                    validate="text"
                    @update:tags="updateApartmentCodeSelect"
                  ></vue-input-tag>
                  <p class="email_default show_email email_activated">
                    {{ apartmentCodeSelect.length }}
                  </p>
                </div>
                <!--  -->
              </div>
              <div class="col-md-12" style="margin-top: 10px">
                <div class="input-group">
                  <span class="input-group-btn">
                    <button class="btn btn-default reveal" type="button">
                      {{ $t("notification.modal_title") }}
                    </button>
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    v-model="notification.title"
                    @input="lengthText(notification.title, 1)"
                    maxlength="62"
                  />
                  <span class="text_length">{{ lengthInputTitle }}/62</span>
                </div>
                <!--  -->
              </div>
              <div class="col-md-12" style="margin-top: 10px">
                <div class="input-group">
                  <span class="input-group-btn">
                    <button class="btn btn-default reveal" type="button">
                      {{ $t("notification.modal_subject") }}
                    </button>
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    v-model="notification.subject"
                    @input="lengthText(notification.subject, 2)"
                    maxlength="62"
                  />
                  <span class="text_length">{{ lengthInputSubject }}/62</span>
                </div>

                <!--  -->
              </div>
              <div class="col-md-12" style="margin-top: 10px">
                <div class="form-group">
                  <div class="modal_content">
                    <label>{{ $t("notification.modal_content") }}</label>
                    <label class="pull-right" style="color: #a7a0a0"
                      >{{ lengthInputContent }}/110</label
                    >
                  </div>
                  <b-form-textarea
                    type="text"
                    class="form-control"
                    v-model="notification.content"
                    rows="8"
                    :placeholder="$t('notification.modal_content')"
                    @input="lengthText(notification.content, 3)"
                    maxlength="110"
                  />
                </div>
              </div>
              <div class="box-footer">
                <!-- button close -->
                <lte-button
                  id="searchButton"
                  type="button"
                  class="btn btn-labeled btn-danger"
                  @click="closeNotification"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-remove"></i>
                  </span>
                  {{ $t("notification.btn_close") }}
                </lte-button>
                <!-- button send notification -->
                <lte-button
                  id="searchButton"
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="sendNotification"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-send"></i>
                  </span>
                  {{ $t("notification.btn_send") }}
                </lte-button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("notification.sent_notification") }}</b>
            </div>
          </div>
          <div class="box-body">
            <lte-table
              :hdBackground="hdBackground"
              :data="gridNotificationList"
              :columns="gridColumns"
              :boxStyle="false"
              search_filter="left-search"
              :useFilter="useFilter"
              :actions="null"
              :row_mouse_pointer="false"
            ></lte-table>
            <!-- <lte-table
            :hdBackground="hdBackground"
            :data="gridProjectHistoryDataList"
            :columns="gridColumns"
            :boxStyle="boxStyle"
            search_filter="left-search"
            :useFilter="useFilter"
            :actions="actions"
            :row_mouse_pointer="false"
          ></lte-table> -->
          </div>
        </div>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onPagination"
          />
        </div>
      </div>
    </div>
    <!--  -->
    <select-apartment-modal
      id="modal-select-apartment-send-notification"
      ref="modalSelectApartment"
      @doSelectEmail="doSelectEmail"
    />
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
  </div>
</template>
<script>
import LTEButton from "@/components/LTEButton.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import SelectApartmentModal from "@/components/SelectApartmentModal.vue";
import LTETable from "@/components/LTETable.vue";
import Paginator from "@/components/CustomPaginator.vue";
import Loading from "vue-loading-overlay";
// vue-input-tag
import InputTag from "vue-input-tag";
import { mapActions, mapGetters } from "vuex";
import utils from '@/lib/utils';
export default {
  components: {
    loading: Loading,
    "lte-button": LTEButton,
    "lte-core-alert": LTECoreAlert,
    "select-apartment-modal": SelectApartmentModal,
    "vue-input-tag": InputTag,
    "lte-table": LTETable,
    paginator: Paginator
  },
  data: () => ({
    isLoading: false,
    isShowNotification: false,
    notification: {
      title: null,
      subject: null,
      content: null,
      templateCategoryId: null
    },
    apartmentCodeSelect: [],
    apartmentIdSelect: [],
    apartmentDataList: [],
    lengthInputTitle: 0,
    lengthInputSubject: 0,
    lengthInputContent: 0,
    //
    hdBackground: {
      backgroundColor: "#4b646f",
      color: "white",
      border: "1px solid white"
    },
    gridNotificationList: [],
    useFilter: false,
    gridColumns: [
      { text: "common.nonumber", isHidden: true },
      { text: "notification.date_send", isHidden: true, wrapText: 'nowrap' },
      {
        text: "notification.modal_title",
        isHidden: true,
        width: '200px'
      },
      // { name: "notification.modal_title", style: { width: '20%' }},
      {
        text: "notification.modal_content",
        isHidden: true
      },
      {
        text: "notification.total_sent",
        isHidden: true,
        align: 'center'
      },
      {
        text: "notification.total_sent_success",
        isHidden: true,
        align: 'center'
      }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    }
  }),
  watch: {
    GET_NOTIFICATION_DATA: function() {
      let paginate = this.GET_NOTIFICATION_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_NOTIFICATION_DATA.results;
      this.gridNotificationList = [];
      data.forEach((data, i) => {
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;

        let content = data.body;
        let date_send = utils.formatSqlDate(data.date_created, null, "DD-MM-YYYY HH:mm");
        let title = data.title;
        let total_sent = data.total_sent;
        let total_sent_success = data.total_sent_success;
        let data_notification = {
          "common.nonumber": nonumber,
          "notification.modal_content": content,
          "notification.date_send": date_send,
          "notification.modal_title": title,
          "notification.total_sent": total_sent,
          "notification.total_sent_success": total_sent_success
        };
        this.gridNotificationList.push(data_notification);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_NOTIFICATION_DATA"
    ])
  },
  methods: {
    doOpenNotification: function() {
      this.isShowNotification = !this.isShowNotification;
    },
    closeNotification: function() {
      this.isShowNotification = false;
    },
    lengthText: function(text, value) {
      if (value == 1) {
        this.lengthInputTitle = text.length;
        return this.lengthInputTitle;
      } else if (value == 2) {
        this.lengthInputSubject = text.length;
        return this.lengthInputSubject;
      } else {
        this.lengthInputContent = text.length;
        return this.lengthInputContent;
      }
    },
    //
    doOpenUser(callBack) {
      this.$refs.modalSelectApartment.setCallBackFunction(callBack);
      $("#modal-select-apartment-send-notification").modal("show");
    },
    doSelectEmail(data) {
      if (data.callBackFrom == "TO") {
        this.apartmentCodeSelect = data.tagsApartmentCode;
        this.apartmentIdSelect = data.apartmentCodeIds;
        this.apartmentDataList = data.apartmentDataList;
      }
    },
    //
    validateData: function() {
      let validatedResult = "OK";
      for (let key in this.notification) {
        if (key == "subject" || key == "templateCategoryId") {
          //
        } else if (
          this.notification[key] === null ||
          this.notification[key] === ""
        ) {
          validatedResult =
            "Xin vui lòng nhập/chọn " + this.$t("notification.modal_" + key);
          break;
        } else if (this.subject_select == "") {
          validatedResult =
            "Xin vui lòng nhập/chọn " + this.$t("notification.choose_subject");
        }
      }
      if (this.apartmentIdSelect.length === 0) {
        validatedResult = this.$t("notification.errorSelectApartment");
      }
      return validatedResult;
    },
    sendNotification: function() {
      let result = this.validateData();
      if (result == "OK") {
        let data = {
          message_sub_title: this.notification.subject,
          message_title: this.notification.title,
          message_body: this.notification.content,
          apartmentIdSelect: this.apartmentIdSelect
        };
        this.isLoading = true;
        this.SEND_NOTIFICATION_TO_APARTMENT(data)
          .then(
            function() {
              this.getNotificationList(this.paginateData.currentPage);
              this.notification.content = null;
              this.SUCCESS_TOAST();
              this.isLoading = false;
            }.bind(this)
          )
          .catch(
            function(error) {
              let error_message = error.response.data.message;
              if (error_message == "not_found_user_device") {
                this.ON_SHOW_TOAST({
                  message: this.$t("notification.not_found_user_device"),
                  styleType: "danger"
                });
              } else {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }
              this.isLoading = false;
            }.bind(this)
          );
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    updateApartmentCodeSelect: function(data) {
      this.apartmentIdSelect = [];
      this.apartmentDataList.forEach(item => {
        if (data.includes(item.apartmentCode)) {
          this.apartmentIdSelect.push(item.id);
        }
      });
    },
    getNotificationList: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.isLoading = true;
      this.GET_NOTIFICATION(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onPagination: function(data) {
      this.getNotificationList(data);
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SEND_NOTIFICATION_TO_APARTMENT",
      "GET_NOTIFICATION"
    ])
  },
  mounted() {
    this.getNotificationList(1);
  }
};
</script>
<style scoped>
.modal_content {
  border: 1px solid #ccc !important;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  height: 30px;
  background: #f4f4f4;
}
.modal_content label {
  font-weight: 400;
  padding: 4px 12px 0 12px;
}
.text_length {
  position: absolute;
  padding: 2px 8px;
  right: 5px;
  z-index: 999;
  top: 11.3%;
  color: #a7a0a0;
}

/*  */
.email_default {
  padding: 2px 8px;
  position: absolute;
  top: 18px;
  right: 8px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.show_email {
  display: block !important;
}
.email_activated {
  background: #06a65a;
  color: rgba(255, 255, 255, 0.9);
  font-family: "Glyphicons Halflings";
}
</style>



// WEBPACK FOOTER //
// src/views/Mailbox/SendNotification.vue